// removed by extract-text-webpack-plugin
module.exports = {"modalBody":"_35CPu _1-OXK _3ibIU _3Xg8b","modalTextArea":"SzTSh _3_vf0 _2QXSI _1bHiY _2Eplg"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/RevisionMessageModal.css
// module id = 2229
// module chunks = 3